export default __webpack_public_path__ + "static/media/bot2.3db5624b.jpg";